// extracted by mini-css-extract-plugin
module.exports = {"loader":"_20xqu","animate":"_1v0XX"};